export const isString = (object: any) => {
    return typeof object === 'string';
};
